import { render, staticRenderFns } from "./NarrativeBuilderIndex.vue?vue&type=template&id=38fd8f16&scoped=true&"
import script from "./NarrativeBuilderIndex.vue?vue&type=script&lang=js&"
export * from "./NarrativeBuilderIndex.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeBuilderIndex.vue?vue&type=style&index=0&id=38fd8f16&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fd8f16",
  null
  
)

export default component.exports